import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';

import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/Rx';

import { Account } from '../../model/account';
import { MonitoringService } from '../../services/AppInsights/monitoring-service';

@Injectable()
export class UserManager {
    private _account: BehaviorSubject<Account> = new BehaviorSubject(new Account());
    public readonly account: Observable<Account> = this._account.asObservable();

    constructor(private storage: Storage, private monitoringService: MonitoringService) {
        this.storage.get("account")
            .then((data) => {
                if (data) {
                    this.receiveAccount(data);
                    this.monitoringService.setUserId(data.emailAddress);
                } 
            });
    }

    receiveAccount(account: Account) {
        if (account) {
            let newAccount: Account = new Account();
            Object.assign(newAccount, account);
            this._account.next(newAccount);

            if (newAccount.id) {
                this.storage.set("account", newAccount);
                this.monitoringService.setUserId(newAccount.emailAddress);
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/services/managers/user.manager.ts